import Vue from 'vue'
import types from '../types'

const state = {
  loadCount: 0,
  loadingText: '',
  isLoading: false,
  isInitEditor: true
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.mutations.APP_LOADING](state: any, isLoading: boolean): void {
    if (isLoading) {
      state.loadCount += 1
      state.isLoading = isLoading
    } else {
      state.loadCount -= 1

      if (state.loadCount <= 0) {
        state.loadCount = 0
        state.isLoading = isLoading
        state.loadingText = ''
      }
    }
  },
  [types.mutations.APP_LOADING_TEXT](state: any, loadingText: string): void {
    Vue.set(state, 'loadingText', loadingText)
  },
  [types.mutations.APP_INIT_EDITOR](state: any, isInitEditor: boolean): void {
    Vue.set(state, 'isInitEditor', isInitEditor)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
